import { JsonApiDatastore } from './services/json-api-datastore.service';

export * from './services/json-api-datastore.service';

export const PROVIDERS: any[] = [
  JsonApiDatastore
];
